// src/data/onboardingOptions.ts
export type UsageIntent = "study" | "teacher" | "work" | "personal";

export const USAGE_INTENTS: { label: string; value: UsageIntent }[] = [
  { label: "Study", value: "study" },
  { label: "Teacher", value: "teacher" },
  { label: "Work", value: "work" },
  { label: "Personal", value: "personal" },
];

export const SCHOOLS_UNIVERSITIES: string[] = [
  // 🇸🇦 Saudi Arabia – key universities
  "King Saud University",
  "King Abdulaziz University",
  "King Fahd University of Petroleum & Minerals",
  "Imam Mohammad Ibn Saud Islamic University",
  "Umm Al-Qura University",
  "Princess Nourah bint Abdulrahman University",
  "Taibah University",
  "Taif University",
  "Jeddah University",
  "Effat University",
  "Batterjee Medical College",
  "University of Business & Technology",

  // 🇹🇳 Tunisia
  "National Institute of Applied Science and Technology (INSAT)",

  // 🇸🇦 Saudi – representative schools
  "Jeddah Prep & Grammar School",
  "American International School of Jeddah",
  "British International School Riyadh",
  "Manarat Jeddah High School",
  "Dar Al Fikr High School",
  "Kingdom Schools Riyadh",

  // 🌍 Major global universities
  "Harvard University",
  "Stanford University",
  "Massachusetts Institute of Technology (MIT)",
  "Saint Joseph University (USJ)",
  "University of California, Berkeley",
  "University of Oxford",
  "University of Cambridge",
  "University of Toronto",
  "National University of Singapore",
  "Technical University of Munich",
  "University of Tokyo",
];

export const COURSES_MAJORS: string[] = [
  "Computer Science",
  "Mathematics",
  "Physics",
  "Chemistry",
  "Biology",
  "Engineering",
  "Software Engineering",
  "Economics",
  "Psychology",
  "Business Administration",
  "Medicine",
  "Law",
  "Literature",
  // INSAT majors
  "Software Engineering (GL)",
  "Networks and Telecommunications (RT)",
  "Industrial IT and Automation (IIA)",
  "Instrumentation and Industrial Maintenance (IMI)",
  "Industrial Chemistry (CH)",
  "Industrial Biology (BIO)",
];

/** @deprecated use COURSES_MAJORS */
export const COURSES = COURSES_MAJORS;

export const ROLES: string[] = [
  // Tech
  "Software Engineer",
  "Data Scientist",
  "Product Manager",
  "Designer",
  "UX/UI Designer",
  "Web Developer",
  "Mobile Developer",
  "DevOps Engineer",
  "Cybersecurity Specialist",
  "AI/ML Engineer",

  // Business
  "Marketing Professional",
  "Sales Professional",
  "Consultant",
  "Entrepreneur",
  "Business Analyst",
  "Project Manager",
  "Operations Manager",
  "Account Manager",
  "Business Owner",
  "Startup Founder",

  // Healthcare
  "Healthcare Professional",
  "Doctor/Physician",
  "Nurse",
  "Therapist/Counselor",
  "Pharmacist",

  // Finance & Legal
  "Finance Professional",
  "Accountant",
  "Financial Advisor",
  "Investment Banker",
  "Lawyer",
  "Paralegal",

  // Research & Education
  "Teacher",
  "Researcher",
  "Scientist",
  "Lab Technician",
];

export const SKILLS: string[] = [
  // Tech
  "Programming",
  "Data Analysis",
  "Web Development",
  "Mobile Development",
  "UI/UX Design",
  "Cybersecurity",
  "Cloud Computing",
  "Artificial Intelligence",
  "Machine Learning",

  // Business & Ops
  "Business Analysis",
  "Project Management",
  "Strategic Planning",
  "Operations Management",
  "Supply Chain Management",
  "Risk Management",

  // Marketing & Growth
  "Digital Marketing",
  "Content Marketing",
  "Social Media Marketing",
  "SEO/SEM",
  "Email Marketing",
  "Sales",
  "Customer Relationship Management",

  // General
  "Entrepreneurship",
  "Business Development",
  "Mentoring",
  "Healthcare",
  "Finance",
  "Legal",
  "Real Estate",
  "Hospitality",
  "Retail",
  "Manufacturing",
  "Consulting",
];
